/** Firestore limit for `in`, `not-in`, and `array-contains-any` filters. */
export const FIRESTORE_IN_QUERY_MAX = 30;

/** Split values into batches safe for a single `in` (or similar) filter. */
export function chunkForFirestoreIn<T>(values: readonly T[]): T[][] {
	if (!values.length) {
		return [];
	}
	const batches: T[][] = [];
	for (let i = 0; i < values.length; i += FIRESTORE_IN_QUERY_MAX) {
		batches.push(values.slice(i, i + FIRESTORE_IN_QUERY_MAX));
	}
	return batches;
}
